export default __webpack_public_path__ + "static/media/culture.e94bc331.png";